import { render, staticRenderFns } from "./send-otp.vue?vue&type=template&id=3bbc6b32&scoped=true&"
import script from "./send-otp.vue?vue&type=script&lang=js&"
export * from "./send-otp.vue?vue&type=script&lang=js&"
import style0 from "./send-otp.vue?vue&type=style&index=0&id=3bbc6b32&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=3bbc6b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc6b32",
  null
  
)

component.options.__file = "send-otp.vue"
export default component.exports